import React from "react";
import { connect } from "react-redux";

import TextChart from "../../../../Charts/TextChart";

const TextoSaldoCliente = (props) => {
  const { clientSelected, cliente, onBodyClick } = props;

  return (
    <TextChart
      title={`Saldo del cliente`}
      bigAmount={clientSelected ? cliente.deuda.importe : 0}
      noClient={!clientSelected}
      bigCurrency
      currencySimbol={clientSelected ? cliente.cuentaCorriente.moneda : null}
      loading={false}
      onBodyClick={() => onBodyClick()}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    clientSelected: state.clientes.clienteById.clientSelected,
    cliente: state.clientes.clienteById.cliente,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(TextoSaldoCliente);